var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.name != 'notfound')?_c('AppHeader'):_vm._e(),_c('v-main',{staticClass:"body",style:({'padding-top' : _vm.$store.getters.permissions.includes('video')  ? '0!important' : '50px!important'})},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }